import { Button, Input, message, Modal, Popconfirm } from "antd";
import { diffSentences } from "diff";
import { memo, useCallback, useEffect, useState } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import { connect } from "react-redux";
import Flag from "../../../../Components/Flag/Flag";
import FlagsMenu from "../../../../Components/FlagsMenu/FlagsMenu";
import Loading from "../../../../Components/Loading/Loading";
import Term from "../../../../Components/Term/Term";
import * as actions from "../../../../store/actions/action";
import getUnusedFlags from "../../../../Util/getUnusedFlags";
import {
  findFlagPositionFromArrayTerms,
  findTermAndIndexOfPreOfFlag,
  insertFlagIntoTerm,
  isAllFlagsAddedToTerms,
} from "../UserRoadmap";
import styles from "../UserRoadmap.module.css";

const ActionsRoadmap = ({
  LoadingSetter,
  segment = "all",
  getFlagImportance = () => 0,
  rePositionPrevHiddenFlags = () => null,
  checkIsDeletedFlag = () => false,
  setSegment = () => {},
  getFlagExistingConflict = () => [],
  resortPrevFlag = (flagId, tempFlags) => {},
  operatorData = {},
  flagsHistory = {},
  transparentMode,
  checkOverFlowFlag = (flagId) => false,
  toggleImportance = () => null,
  flagImportance = 0,
  getIgnoreFlagsSingle,
  ignoreFlagsFromGenerator = (a) => a,
  checkHistory,
  loading,
  ClearLoading,
  getIgnoreFlagsBaseOnTag,
  roadmapId,
  termIndexFinder,
  globalSearch,
  terms,
  setTerms,
  flags,
  setFlags,
  flagsRef,
  isRoadmapChanged,
  setIsRoadmapChanged,
  userData,
  mapPreAndPostConditionFlags,
  relatedFlagsList = [],
  allRoadmapFlags = [],
  ignoreImportanceArr = [],
  otherRoadmapsFlagIds = [],
}) => {
  const [editFlagModal, setEditFlagModal] = useState(null);
  const [newFlagDescription, setNewFlagDescription] = useState(null);
  const [updateForcer, setUpdateForcer] = useState(0);
  const [showRelatedFlags, setShowRelatedFlags] = useState(false);
  const [controlStatus, setControlStatus] = useState(""); // pressed || released
  const [flagCategory, setFlagCategory] = useState(["all"]);
  const [deleteFlagsArr, setDeleteFlagsArr] = useState([]);

  const updateFlagDescription = () => {
    if (!newFlagDescription || newFlagDescription === "") {
      return;
    }
    const newTerms = terms;
    const newFlags = newTerms[editFlagModal.termId].flags.map((flag) => {
      if (flag.id === editFlagModal.id) {
        const newFlag = flag;
        newFlag.description = newFlagDescription;
        return newFlag;
      }
      return flag;
    });
    newTerms[editFlagModal.termId].flags = newFlags;
    setTerms(newTerms);
    setNewFlagDescription(null);
    setIsRoadmapChanged(true);
    setTimeout(() => {
      setUpdateForcer(updateForcer + 1);
    });
  };

  const toggleFlagConfirmation = (termId, flagId) => {
    const newTerms = terms;
    const newFlags = newTerms[termId].flags.map((flag) => {
      if (flag.id === flagId) {
        const newFlag = flag;
        let flagIsConfirmed = false;
        if (flag.confirmed) {
          flagIsConfirmed = flag.confirmed;
        }
        newFlag.confirmed = !flagIsConfirmed;
        return newFlag;
      }
      return flag;
    });
    newTerms[termId].flags = newFlags;
    setTerms(newTerms);
    setIsRoadmapChanged(true);
    setTimeout(() => {
      setUpdateForcer(updateForcer + 1);
    });
  };

  const resetFlag = () => {
    let flagRef = null;
    if (Array.isArray(flagsRef)) {
      flagsRef.forEach((el) => {
        if (el.id === editFlagModal.id) {
          flagRef = el;
        }
      });
    }
    if (!flagRef) {
      return;
    }
    const newTerms = terms;
    const newFlags = newTerms[editFlagModal.termId].flags.map((flag) => {
      if (flag.id === editFlagModal.id) {
        setEditFlagModal(flagRef);
        return flagRef;
      }
      return flag;
    });
    newTerms[editFlagModal.termId].flags = newFlags;
    setTerms(newTerms);
    setEditFlagModal(null);
  };

  const deleteFlagsAsGroup = useCallback(
    (arr) => {
      setTerms((prevTerms) => {
        let r = {
          term1: {
            ...prevTerms.term1,
            flags: prevTerms.term1.flags.filter((e) => !arr.includes(e.id)),
          },
          term2: {
            ...prevTerms.term2,
            flags: prevTerms.term2.flags.filter((e) => !arr.includes(e.id)),
          },
          term3: {
            ...prevTerms.term3,
            flags: prevTerms.term3.flags.filter((e) => !arr.includes(e.id)),
          },
          term4: {
            ...prevTerms.term4,
            flags: prevTerms.term4.flags.filter((e) => !arr.includes(e.id)),
          },
        };

        for (const a of arr) {
          r = rePositionPrevHiddenFlags(a, r, false);
          // rePositionPrevHiddenFlags(a, r, false);
        }

        return r;
      });
      setFlags((prev) =>
        [
          ...Array.from(new Set(arr))
            .map((id) => findFlagRef({ id }, flagsRef))
            .filter((e) => e),
          ...prev,
        ].filter((e) => e)
      );

      setIsRoadmapChanged(true);
      setTimeout(() => setUpdateForcer((p) => p + 1));
    },
    [flags, terms]
  );

  const deleteFlag = (flagId) => {
    if (controlStatus === "pressed") {
      // const newArr = deleteFlagsArr.includes(flagId)
      //   ? deleteFlagsArr.filter((e) => e !== flagId)
      //   : [...deleteFlagsArr, flagId];
      // setDeleteFlagsArr(newArr);
    } else {
      deleteFlagsAsGroup([flagId]);
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Alt" || event.key === "Meta") {
        setControlStatus("pressed");
        setDeleteFlagsArr([]);
      }
    };

    const handleKeyUp = (event) => {
      if (event.key === "Alt" || event.key === "Meta") {
        setControlStatus("released");
        if (deleteFlagsArr.length > 0) {
          deleteFlagsAsGroup(deleteFlagsArr);
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [deleteFlagsArr, deleteFlagsAsGroup]);

  useEffect(() => {
    if (isRoadmapChanged) {
      window.onbeforeunload = function (e) {
        return true;
      };
    } else {
      window.onbeforeunload = null;
    }
    return () => {
      window.onbeforeunload = null;
    };
  }, [isRoadmapChanged]);

  useEffect(() => {
    if (!terms) return;

    const seenTermIds = new Set();
    let termsChanged = false;

    const cleanedTerms = {};
    Object.keys(terms).forEach((key) => {
      const term = terms[key];
      const list = Array.isArray(term?.flags) ? term.flags : [];
      const cleaned = [];
      list.forEach((flag) => {
        const idKey =
          flag == null || flag.id == null || flag.id === ""
            ? null
            : `${flag.id}`;
        if (idKey === null || seenTermIds.has(idKey)) {
          termsChanged = true;
          return;
        }
        seenTermIds.add(idKey);
        cleaned.push(flag);
      });
      cleanedTerms[key] =
        cleaned.length === list.length ? term : { ...term, flags: cleaned };
    });

    let cleanedFlags = flags;
    let flagsChanged = false;
    if (Array.isArray(flags)) {
      const seenMenuIds = new Set();
      cleanedFlags = flags.filter((flag) => {
        const idKey =
          flag == null || flag.id == null || flag.id === ""
            ? null
            : `${flag.id}`;
        if (idKey === null || seenTermIds.has(idKey) || seenMenuIds.has(idKey)) {
          return false;
        }
        seenMenuIds.add(idKey);
        return true;
      });
      flagsChanged = cleanedFlags.length !== flags.length;
    }

    if (termsChanged || flagsChanged) {
      console.warn(
        "ActionsRoadmap: removed invalid or duplicate draggable flags to keep drag-and-drop ids unique",
        { termsChanged, flagsChanged }
      );
    }
    if (termsChanged) setTerms(cleanedTerms);
    if (flagsChanged) setFlags(cleanedFlags);
  }, [terms, flags, setTerms, setFlags]);

  const sortFlags = (fls) => {
    const removedFlags =
      fls?.filter((fl) => checkFlagIsRemovedFromFlagsMenu(fl.id)) ?? [];
    const nonRemovedFlags =
      fls?.filter((fl) => !checkFlagIsRemovedFromFlagsMenu(fl.id)) ?? [];

    return [...removedFlags, ...nonRemovedFlags];
  };

  const onDragEnd_V01 = (result) => {
    const { destination, source, draggableId } = result;

    if (source.droppableId === "flags" && destination.droppableId === "flags") {
      return;
    }

    setIsRoadmapChanged(true);
    const start = terms[source.droppableId];
    const end = terms[destination.droppableId];
    if (end?.flags?.length === 8) {
      message.warning(".بیش از 8 کارت در یک بازه زمانی نمی‌توان داد");
    }

    if (source.droppableId === "flags") {
      console.warn("reach02");
      const newTerms = structuredClone(terms);
      let allTermsFlags = [
        newTerms?.term1?.flags,
        newTerms?.term2?.flags,
        newTerms?.term3?.flags,
        newTerms?.term4?.flags,
      ];
      let allTermsDestructedFlags = [
        ...newTerms?.term1?.flags,
        ...newTerms?.term2?.flags,
        ...newTerms?.term3?.flags,
        ...newTerms?.term4?.flags,
      ];

      let targetFlag = flags?.find((e) => e?.id == draggableId);
      targetFlag = { ...targetFlag, addedUser: operatorData };
      if (!targetFlag) return;

      // all flags -> main + all pre + all post
      let allFlags = [targetFlag];
      let current = [targetFlag];
      for (let index = 0; index < 100; index++) {
        const tempFF = [];
        current.forEach((flag) => {
          const post = flag?.postConditionFlags?.map((el) =>
            findFlagRef(el, flags)
          );
          const pre = flag?.preConditionFlags?.map((el) =>
            findFlagRef(el, flags)
          );

          const temp = [...post, ...pre]
            .filter((ac) => !allFlags.find((obj) => obj?.id === ac?.id))
            .filter((c) => c);

          allFlags.push(...temp);
          tempFF.push(...temp);
        });

        if (tempFF.length === 0) break;
        current = tempFF;
      }
      console.log("first", { allFlags });
      allFlags = ignoreFlagsFromGenerator(allFlags);
      console.log("second", { sec: ignoreFlagsFromGenerator(allFlags) });

      allFlags = allFlags.map((flag, _, clone) => {
        if (
          flag?.bookmarkQuestionId ||
          flag.addedUser ||
          flag.autoGenerated ||
          flag.postConditionGenerated ||
          flag.preConditionGenerated
        ) {
          return flag;
        }

        const post = clone
          .filter((d) => d?.postConditionFlags?.find((a) => a.id === flag.id))
          .map(({ id, title }) => ({ id, title }));

        const pre = clone
          .filter((d) => d?.preConditionFlags?.find((a) => a.id === flag.id))
          .map(({ id, title }) => ({ id, title }));

        return {
          ...flag,
          report: {
            pre: pre.filter((e) => allRoadmapFlags.includes(e.id)),
            post: post.filter((e) => allRoadmapFlags.includes(e.id)),
          },
          addedUser: userData,
          addedDate: new Date(),
        };
      });

      const mainFlags = [targetFlag];
      // const nonMainFlags = allFlags.filter(({ id }) => targetFlag.id !== id);

      // just include pre that are in Main level
      let mainFlagsWithMinorPre = mainFlags.map((flag, _, clone) => {
        const preOfOther = [...clone, ...allTermsDestructedFlags].filter((fl) =>
          fl?.postConditionFlags?.find((el) => el.id === flag.id)
        );

        return {
          ...flag,
          postConditionFlags: [],
          preConditionFlags: [
            ...preOfOther,
            ...flag.preConditionFlags.filter(({ id }) =>
              [...clone, ...allTermsDestructedFlags].find(
                (val) => val.id === id
              )
            ),
          ],
        };
      });

      // // just include pre that are in non-Main level
      // let nonMainFlagsWithMinorPre = nonMainFlags.map((flag) => {
      //   const preOfOther = [...allFlags, ...allTermsDestructedFlags].filter(
      //     (fl) => fl.postConditionFlags.find((el) => el.id === flag.id)
      //   );
      //   const filteredPre = flag.preConditionFlags.filter((fl) =>
      //     [...allFlags, ...allTermsDestructedFlags].find(
      //       (el) => el.id === fl.id
      //     )
      //   );

      //   return {
      //     ...flag,
      //     postConditionFlags: [],
      //     preConditionFlags: [...preOfOther, ...filteredPre].filter(({ id }) =>
      //       [...allFlags, ...allTermsDestructedFlags].find(
      //         (val) => val.id === id
      //       )
      //     ),
      //   };
      // });

      // // just include post that are in non-Main level
      // let nonMainFlagsWithMinorPost = allFlags.map((flag, _, clone) => {
      //   const postOfOther = [...allFlags, ...allTermsDestructedFlags].filter(
      //     (fl) => fl.preConditionFlags.find((el) => el.id === flag.id)
      //   );

      //   return {
      //     ...flag,
      //     postConditionFlags: [
      //       ...postOfOther,
      //       ...flag.postConditionFlags.filter(({ id }) =>
      //         [...clone, ...allTermsDestructedFlags].find(
      //           (val) => val.id === id
      //         )
      //       ),
      //     ],
      //     preConditionFlags: [],
      //   };
      // });

      // sort main flags -> base on pre
      for (let index = 0; index < 1000; index++) {
        // get one flag
        // eslint-disable-next-line no-loop-func
        let targetFlag = mainFlagsWithMinorPre.find((fl) => {
          const preFlags = (fl?.preConditionFlags ?? []).map(({ id }) => id);
          // are flags rendered
          return isAllFlagsAddedToTerms(preFlags, allTermsFlags);
        });

        if (!targetFlag) break;

        const flagRef = findFlagRef(targetFlag, flags);
        if (!flagRef) break;
        targetFlag = {
          ...targetFlag,
          postConditionFlags: (flagRef.postConditionFlags ?? []).filter((e) =>
            allRoadmapFlags.includes(e.id)
          ),
          preConditionFlags: (flagRef.preConditionFlags ?? []).filter((e) =>
            allRoadmapFlags.includes(e.id)
          ),
        };

        // check conditions
        const placement = { termIndex: 2, flagIndex: destination.index - 1 };

        // check manual placement
        let manualTermIndex = +destination.droppableId.replace("term", "") - 1;

        const conditions = findTermAndIndexOfPreOfFlag(
          targetFlag,
          allTermsFlags
        );

        if (conditions.length !== 0) {
          // find min of termIndex from preConditions
          let tempTermIndex = Math.max(
            ...conditions.map((val) => val.termIndex)
          );
          let tempFlagIndex = destination.index;

          tempTermIndex = Math.max(manualTermIndex, tempTermIndex);

          const cc = conditions
            .filter((c) => c.termIndex === tempTermIndex)
            .map((val) => val.flagIndex);

          tempFlagIndex = destination.index;
          if (cc.length !== 0) {
            tempFlagIndex = Math.max(...cc, destination.index);
          }

          placement.flagIndex = tempFlagIndex;
          placement.termIndex = tempTermIndex;
        } else {
          placement.termIndex = manualTermIndex;
        }

        console.log("manual - main flags", {
          targetFlag,
          conditions,
          manualTermIndex,
          placement,
        });

        console.log({ allTermsFlags });
        // insert flag into terms
        allTermsFlags = insertFlagIntoTerm({
          flag: targetFlag,
          termIndex: placement.termIndex,
          colIndex: placement.flagIndex,
          terms: allTermsFlags,
        });

        // remove from mainFlagsWithMinorPostPre
        mainFlagsWithMinorPre = mainFlagsWithMinorPre.filter(
          ({ id }) => id !== targetFlag.id
        );
      }

      // // sort non-main flags -> base on pre
      // for (let index = 0; index < 1000; index++) {
      //   // get one flag
      //   // eslint-disable-next-line no-loop-func
      //   let targetFlag = nonMainFlagsWithMinorPre.find((fl) => {
      //     const preFlags = fl.preConditionFlags.map(({ id }) => id);
      //     if (preFlags.length === 0) return false;
      //     // are flags rendered
      //     return isOneOfFlagsAddedToTerms(preFlags, allTermsFlags);
      //   });

      //   if (!targetFlag) break;

      //   const flagRef = findFlagRef(targetFlag, flags);

      //   // check conditions
      //   const placement = { termIndex: 0, flagIndex: 0 };
      //   const conditions = findTermAndIndexOfPreOfFlag(
      //     targetFlag,
      //     allTermsFlags
      //   );

      //   targetFlag = {
      //     ...targetFlag,
      //     postConditionFlags: flagRef.postConditionFlags,
      //     preConditionFlags: flagRef.preConditionFlags,
      //   };
      //   if (conditions.length !== 0) {
      //     // find min of termIndex from preConditions
      //     const tempTermIndex = Math.max(
      //       ...conditions.map((val) => val.termIndex)
      //     );
      //     // find max of flagIndex from preConditions
      //     const tempFlagIndex = Math.max(
      //       ...conditions
      //         .filter((c) => c.termIndex === tempTermIndex)
      //         .map((val) => val.flagIndex)
      //     );

      //     placement.termIndex = tempTermIndex;
      //     placement.flagIndex = tempFlagIndex;
      //   }

      //   // insert flag into terms
      //   allTermsFlags = insertFlagIntoTerm({
      //     flag: targetFlag,
      //     termIndex: placement.termIndex,
      //     colIndex: placement.flagIndex,
      //     terms: allTermsFlags,
      //   });

      //   console.log("bookmark: non-main flags 01 - pre", {
      //     targetFlag,
      //     conditions,
      //     placement,
      //   });

      //   // remove from mainFlagsWithMinorPre
      //   nonMainFlagsWithMinorPre = nonMainFlagsWithMinorPre.filter(
      //     ({ id }) => id !== targetFlag.id
      //   );
      // }

      // // filter non-main flags with post relation that not exists in rendered list
      // nonMainFlagsWithMinorPost = nonMainFlagsWithMinorPost.filter(
      //   ({ id }) =>
      //     !allTermsFlags.find((term) => term.find((fl) => fl.id === id))
      // );

      // sort non-main flags -> base on post
      // console.log({ nonMainFlagsWithMinorPost });
      // for (let index = 0; index < 1000; index++) {
      //   // get one flag
      //   // eslint-disable-next-line no-loop-func
      //   let targetFlag = nonMainFlagsWithMinorPost.find((fl) => {
      //     const postFlags = fl.postConditionFlags.map(({ id }) => id);
      //     if (postFlags.length === 0) return false;
      //     // check is one flag rendered
      //     return isOneOfFlagsAddedToTerms(postFlags, allTermsFlags);
      //   });

      //   if (!targetFlag) break;

      //   const flagRef = findFlagRef(targetFlag, flags);
      //   targetFlag = {
      //     ...targetFlag,
      //     postConditionFlags: flagRef.postConditionFlags,
      //     preConditionFlags: flagRef.preConditionFlags,
      //   };

      //   // check conditions
      //   const placement = { termIndex: 0, flagIndex: 0 };
      //   const conditions = findTermAndIndexOfPostOfFlag(
      //     targetFlag,
      //     allTermsFlags
      //   );
      //   if (conditions.length !== 0) {
      //     // find min of termIndex from preConditions
      //     const tempTermIndex = Math.min(
      //       ...conditions.map((val) => val.termIndex)
      //     );
      //     // find max of flagIndex from preConditions
      //     const tempFlagIndex = Math.min(
      //       ...conditions
      //         .filter((c) => c.termIndex === tempTermIndex)
      //         .map((val) => val.flagIndex)
      //     );

      //     placement.flagIndex = tempFlagIndex;
      //     placement.termIndex = tempTermIndex;
      //   }

      //   // insert flag into terms
      //   allTermsFlags = insertFlagIntoTerm({
      //     flag: targetFlag,
      //     termIndex: placement.termIndex,
      //     colIndex: placement.flagIndex - 1,
      //     terms: allTermsFlags,
      //   });

      //   console.log("manual: non-main flags 02 - post", {
      //     targetFlag,
      //     conditions,
      //     placement,
      //   });

      //   // remove from mainFlagsWithMinorPostPre
      //   nonMainFlagsWithMinorPost = nonMainFlagsWithMinorPost.filter(
      //     ({ id }) => id !== targetFlag.id
      //   );
      // }

      setTerms(newTerms);
      setFlags((prev) => getUnusedFlags(newTerms, prev));

      console.log({ allFlags });
      return { allFlags };
    } else {
      if (start === end) {
        const newTermFlags = Array.from(start.flags);
        const [removed] = newTermFlags.splice(source.index, 1);
        newTermFlags.splice(destination.index, 0, removed);
        const newTerms = structuredClone(terms);
        const newStart = { ...start, flags: newTermFlags };
        newTerms[source.droppableId] = newStart;
        setTerms(newTerms);
      }

      if (destination.droppableId === "flags") {
        const newTerms = terms;
        const newFlags = flags;
        const sourceFlag = start.flags[source.index];
        const flagRef = findFlagRef(sourceFlag, flagsRef);
        newTerms[source.droppableId].flags.splice(
          start.flags.indexOf(sourceFlag),
          1
        );
        setTerms(newTerms);
        setFlags([flagRef, ...newFlags]);
      } else {
        const newStart = start;
        const newEnd = end;
        const newTerms = terms;
        const sourceFlag = start.flags[source.index];
        [1, 2, 3, 4].forEach((e) => {
          newTerms[`term${e}`].flags = newTerms[`term${e}`].flags.filter(
            (fl) => fl.id !== sourceFlag.id
          );
        });
        newEnd.flags.splice(destination.index, 0, sourceFlag);

        newTerms[destination.droppableId] = newEnd;

        setTerms(changeHiddenFlagsBaseOnManualChange(sourceFlag, newTerms));
      }
    }
    setUpdateForcer((p) => p + 1);
  };

  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    if (source.droppableId === "flags" && destination.droppableId === "flags") {
      return;
    }

    setIsRoadmapChanged(true);
    const start = terms[source.droppableId];
    const end = terms[destination.droppableId];
    if (end?.flags?.length === 8) {
      message.warning(".بیش از 8 کارت در یک بازه زمانی نمی‌توان داد");
    }

    if (source.droppableId === "flags") {
      const newTerms = structuredClone(terms);
      let allTermsFlags = [
        newTerms?.term1?.flags,
        newTerms?.term2?.flags,
        newTerms?.term3?.flags,
        newTerms?.term4?.flags,
      ];

      let targetFlag = {
        ...flags?.find((e) => e?.id == draggableId),
        addedUser: operatorData,
      };
      if (!targetFlag.id) return;

      if (ignoreFlagsFromGenerator([targetFlag]).length === 0) {
        message.warning("پرچم مورد نظر حذفی میباشد");
        // return;
      }

      const preOfThisFlagIdList = [
        ...(targetFlag.postConditionFlags ?? []).map((e) => e.id),
        ...allRoadmapFlags.filter((id) =>
          findFlagRef({ id }, flagsRef)?.preConditionFlags?.find(
            (e) => e.id === targetFlag.id
          )
        ),
      ].filter((e) => allRoadmapFlags.includes(e));

      const postOfThisFlagIdList = [
        ...(targetFlag.preConditionFlags ?? []).map((e) => e.id),
        ...allRoadmapFlags.filter((id) =>
          findFlagRef({ id }, flagsRef)?.postConditionFlags?.find(
            (e) => e.id === targetFlag.id
          )
        ),
      ].filter((e) => allRoadmapFlags.includes(e));

      // check conditions
      const placement = {
        termIndex: +destination.droppableId.replace("term", "") - 1,
        flagIndex: destination.index - 1,
      };

      const shouldBePreOfThisCond = preOfThisFlagIdList.map((id) =>
        findFlagPositionFromArrayTerms(id, allTermsFlags)
      );

      const shouldBePostOfThisCond = postOfThisFlagIdList.map((id) =>
        findFlagPositionFromArrayTerms(id, allTermsFlags)
      );

      console.log({ placement, shouldBePreOfThisCond, shouldBePostOfThisCond });
      if (shouldBePostOfThisCond.length > 0) {
        const termIndex = Math.max(
          ...shouldBePostOfThisCond.map((val) => val.termIndex),
          placement.termIndex
        );
        const flagIndex = Math.max(
          ...shouldBePostOfThisCond
            .filter((e) => e.termIndex === termIndex)
            .map((val) => val.flagIndex),
          placement.flagIndex
        );

        placement.termIndex = termIndex;
        placement.flagIndex = flagIndex;
      }

      if (shouldBePreOfThisCond.length > 0) {
        const termIndex = Math.min(
          ...shouldBePreOfThisCond.map((val) => val.termIndex),
          placement.termIndex
        );
        const flagIndex = Math.min(
          Math.min(
            ...shouldBePreOfThisCond
              .filter((e) => e.termIndex === termIndex)
              .map((val) => val.flagIndex)
          ) - 1,
          placement.flagIndex
        );

        placement.termIndex = termIndex;
        placement.flagIndex = flagIndex;
      }

      // insert flag into terms
      allTermsFlags = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex,
        terms: allTermsFlags,
      });

      const hiddenFlags = (findFlagRef(targetFlag, flags)
        ?.preConditionFlags ?? []).map((e) => findFlagRef(e, flagsRef))
        .filter((e) => e && e?.hidden && !allRoadmapFlags.includes(e.id));

      console.log({ hiddenFlags });

      // sort hidden flags
      for (const targetFlag of hiddenFlags) {
        const shouldBePreOfThisFlagsId = [
          +draggableId,
          ...allRoadmapFlags,
        ].filter((id) =>
          findFlagRef({ id }, flagsRef)?.preConditionFlags?.find(
            (e) => e.id === targetFlag.id
          )
        );

        const conditions = shouldBePreOfThisFlagsId.map((id) =>
          findFlagPositionFromArrayTerms(id, allTermsFlags)
        );

        console.log({
          shouldBePreOfThisFlagsId,
          conditions,
          allRoadmapFlags,
        });
        const termIndex = Math.min(...conditions.map((val) => val.termIndex));
        const flagIndex = Math.min(
          ...conditions
            .filter((e) => e.termIndex === termIndex)
            .map((val) => val.flagIndex)
        );

        const insertingFlag = {
          ...targetFlag,
          report: {
            pre: allRoadmapFlags
              .map((id) => findFlagRef({ id }, flagsRef))
              .filter((fl) =>
                fl?.preConditionFlags?.find((e) => e.id === targetFlag.id)
              )
              .map((e) => ({ id: e.id, title: e.title })),
            post: allRoadmapFlags
              .map((id) => findFlagRef({ id }, flagsRef))
              .filter((fl) =>
                fl?.postConditionFlags?.find((e) => e.id === targetFlag.id)
              )
              .map((e) => ({ id: e.id, title: e.title })),
          },
        };

        // insert flag into terms
        allTermsFlags = insertFlagIntoTerm({
          flag: insertingFlag,
          termIndex: conditions.length === 0 ? 0 : termIndex,
          colIndex: conditions.length === 0 ? 0 : flagIndex - 1,
          terms: allTermsFlags,
        });
      }

      setTerms(newTerms);
      setFlags((prev) => getUnusedFlags(newTerms, prev));
    } else {
      if (start === end) {
        const newTermFlags = Array.from(start.flags);
        const [removed] = newTermFlags.splice(source.index, 1);
        newTermFlags.splice(destination.index, 0, removed);
        const newTerms = structuredClone(terms);
        const newStart = { ...start, flags: newTermFlags };
        newTerms[source.droppableId] = newStart;
        setTerms(newTerms);
      }

      if (destination.droppableId === "flags") {
        const newTerms = terms;
        const newFlags = flags;
        const sourceFlag = start.flags[source.index];
        const flagRef = findFlagRef(sourceFlag, flagsRef);
        newTerms[source.droppableId].flags.splice(
          start.flags.indexOf(sourceFlag),
          1
        );
        setTerms(newTerms);
        setFlags([flagRef, ...newFlags]);
      } else {
        const newStart = start;
        const newEnd = end;
        const newTerms = terms;
        const sourceFlag = start.flags[source.index];
        [1, 2, 3, 4].forEach((e) => {
          newTerms[`term${e}`].flags = newTerms[`term${e}`].flags.filter(
            (fl) => fl.id !== sourceFlag.id
          );
        });
        newEnd.flags.splice(destination.index, 0, sourceFlag);

        newTerms[destination.droppableId] = newEnd;

        setTerms(changeHiddenFlagsBaseOnManualChange(sourceFlag, newTerms));
      }
    }
    setUpdateForcer((p) => p + 1);
  };

  const checkFlagIsRemovedFromFlagsMenu = (flId) => {
    if (!checkHistory) return false;

    const { newFlagsHistory } = checkHistory(false);

    if (!newFlagsHistory[+flId]) return false;

    return (
      newFlagsHistory[+flId]?.at(newFlagsHistory[+flId].length - 1).operate ===
      "remove"
    );
  };

  const checkIsFlagMovedInTermsByOperator = (
    isBalanced,
    currentTerm,
    generatorTerm,
    balanceTerm,
    flId
  ) => {
    if (generatorTerm == null) return false;
    if (currentTerm === generatorTerm && !isBalanced) return false;

    if (isBalanced && balanceTerm === currentTerm) {
      return false;
    }
    return true;
  };

  const findFlagPosition = (flagId, terms) => {
    for (const tempTermIndex of [1, 2, 3, 4]) {
      const rowIndexExists = terms[`term${tempTermIndex}`]?.flags.findIndex(
        (e) => e.id === flagId
      );
      if (rowIndexExists === -1) continue;
      return { termIndex: tempTermIndex, rowIndex: rowIndexExists };
    }
    return { termIndex: 1, rowIndex: 0 };
  };

  const changeHiddenFlagsBaseOnManualChange = (flag, termsClone = terms) => {
    const hiddenPreCondition = (flag?.preConditionFlags ?? [])
      .map((e) => findFlagRef(e, flagsRef))
      .filter((e) => e.hidden);

    // all flags in roadmap
    const allFlags = Object.keys(termsClone)
      .map((key) => termsClone[key]?.flags ?? [])
      .flat();
    allFlags.filter((e) => e?.preConditionFlags?.find((el) => el.id === 1));

    const prevHiddenFlags = [1, 2, 3, 4]
      .map((i) =>
        termsClone[`term${i}`]?.flags.filter((e) =>
          hiddenPreCondition.find((el) => el.id === e.id)
        )
      )
      .flat();

    // remove flags from terms
    termsClone = {
      term1: {
        ...termsClone.term1,
        flags: termsClone.term1.flags.filter(
          (e) => !hiddenPreCondition.find((el) => el.id === e.id)
        ),
      },
      term2: {
        ...termsClone.term2,
        flags: termsClone.term2.flags.filter(
          (e) => !hiddenPreCondition.find((el) => el.id === e.id)
        ),
      },
      term3: {
        ...termsClone.term3,
        flags: termsClone.term3.flags.filter(
          (e) => !hiddenPreCondition.find((el) => el.id === e.id)
        ),
      },
      term4: {
        ...termsClone.term4,
        flags: termsClone.term4.flags.filter(
          (e) => !hiddenPreCondition.find((el) => el.id === e.id)
        ),
      },
    };

    for (const hiddenFlag of hiddenPreCondition) {
      const shouldPreOfThis = allFlags
        .filter((e) =>
          e?.preConditionFlags?.find((el) => el?.id === hiddenFlag?.id)
        )
        ?.map((e) => {
          const pos = findFlagPosition(e.id, termsClone);
          return { id: e.id, term: pos.termIndex, index: pos.rowIndex };
        });

      // get best position for this
      const finalTermIndex = Math.min(...shouldPreOfThis.map((e) => e.term));
      const finalRowIndex = Math.min(
        ...shouldPreOfThis
          .filter((e) => e.term === finalTermIndex)
          .map((e) => e.index)
      );

      const findLocalFlag = prevHiddenFlags.find((e) => e.id === hiddenFlag.id);
      if (findLocalFlag) {
        // insert to new position
        termsClone[`term${finalTermIndex}`].flags.splice(
          finalRowIndex,
          0,
          // findFlagRef(hiddenFlag, flagsRef)
          findLocalFlag
        );
      }
    }

    // return terms
    return termsClone;
  };

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <FlagsMenu
          checkIsDeletedFlag={checkIsDeletedFlag}
          relatedFlagsList={relatedFlagsList}
          setSegment={setSegment}
          segment={segment}
          operatorData={operatorData}
          flagsHistory={flagsHistory}
          checkIsRemoved={checkFlagIsRemovedFromFlagsMenu}
          flagCategory={flagCategory}
          setFlagCategory={setFlagCategory}
          showRelatedFlags={showRelatedFlags}
          setShowRelatedFlags={setShowRelatedFlags}
          className={styles.FlagsMenu}
          flags={flags}
          getIgnoreFlagsBaseOnTag={getIgnoreFlagsBaseOnTag}
          getIgnoreFlagsSingle={getIgnoreFlagsSingle}
          globalSearch={globalSearch}
          roadmapId={roadmapId}
        />
        <div
          className={styles.Content}
          style={{
            height: "calc(100vh - 12rem)",
            marginRight: "0.5rem",
            marginLeft: "0.5rem",
          }}
        >
          {terms ? (
            Object.keys(terms).map((key, termIndex) => {
              const term = terms[key];
              const termTitleOnChange = (value) => {
                const newTerms = { ...terms };
                newTerms[key] = { ...newTerms[key], title: value };
                setTerms(newTerms);
              };
              return (
                <Term
                  key={key}
                  id={key}
                  flagCount={term.flags.filter((flag) => !flag?.hidden).length}
                  isFetchedData={roadmapId ? true : false}
                  termTitle={term.title}
                  termTitleOnChange={termTitleOnChange}
                >
                  {term.flags.map((el, index, clone) => {
                    return (
                      <Flag
                        roadmapLimiterOnHistory={false}
                        ignoredFromLimiter={ignoreImportanceArr.includes(el.id)}
                        toggleImportance={toggleImportance}
                        flagImportance={getFlagImportance(el)}
                        merged={el.merged}
                        existsInDeleteList={deleteFlagsArr.includes(el.id)}
                        existsInOtherRoadmaps={otherRoadmapsFlagIds.some((id) => +id === +el.id)}
                        conflicts={getFlagExistingConflict(el.id)}
                        termIndex={termIndex}
                        isTransparent={transparentMode}
                        deleteFlag={deleteFlag}
                        overFlowWarning={checkOverFlowFlag(el.id)}
                        toggleTermIndex={checkIsFlagMovedInTermsByOperator(
                          el?.forcedToMoved,
                          termIndex,
                          el?.generatorTermIndex,
                          el?.balanceTermIndex ?? 0,
                          el
                        )}
                        removeOrAdd={
                          el?.addedUser?.id &&
                          !el.autoGenerated &&
                          !el.bookmarkQuestion &&
                          !el.preConditionGenerated &&
                          !el.postConditionGenerated
                        }
                        termIndexFinder={termIndexFinder}
                        confirmed={el.confirmed ? true : false}
                        flagRef={findFlagRef(el, flagsRef)}
                        active={
                          `${el.description} | ${el.title}`.includes(
                            `${globalSearch}`
                          ) || `${globalSearch}`.trim() === ""
                        }
                        onEdit={() => {
                          setEditFlagModal({ termId: key, ...el });
                        }}
                        {...el}
                        key={el.id}
                        index={index}
                        toggleConfirmation={() => {
                          toggleFlagConfirmation(key, el.id);
                        }}
                      />
                    );
                  })}
                </Term>
              );
            })
          ) : (
            <Loading />
          )}
        </div>
      </DragDropContext>

      {editFlagModal && (
        <Modal
          title={editFlagModal.title}
          open={editFlagModal ? true : false}
          destroyOnClose
          footer={[
            <Popconfirm
              title="آیا از لغو تمامی تغییرات گذشته مطمئن هستید؟"
              onConfirm={() => {
                resetFlag();
              }}
            >
              <Button danger type="text">
                بازگرداندن کارت به حالت اولیه
              </Button>
            </Popconfirm>,
            <Button
              onClick={() => {
                setEditFlagModal(null);
                setNewFlagDescription(null);
              }}
            >
              لغو
            </Button>,
            <Button
              onClick={() => {
                setEditFlagModal(null);
                updateFlagDescription();
              }}
              style={{ backgroundColor: "green", color: "white" }}
            >
              ذخیره
            </Button>,
          ]}
          onCancel={() => {
            setEditFlagModal(null);
            setNewFlagDescription(null);
          }}
          onOk={() => {
            setEditFlagModal(null);
            updateFlagDescription();
          }}
        >
          <Input.TextArea
            style={{ minHeight: "10rem" }}
            className={styles.ModalDescription}
            defaultValue={editFlagModal.description}
            onBlur={(e) => {
              setNewFlagDescription(e.target.value);
            }}
          />
          <DiffDescription flag={editFlagModal} flagsRef={flagsRef} />
        </Modal>
      )}

      {/* <Modal
        title="آیا از حرف کارت ها مطمئن هستید؟"
        open={groupDeleteModal && deleteFlagsArr.length > 0}
        destroyOnClose
        onCancel={() => {
          setGroupDeleteModal(false);
          setDeleteFlagsArr([]);
        }}
        onOk={() => {
          deleteFlagsAsGroup(deleteFlagsArr);
          setGroupDeleteModal(false);
        }}
      ></Modal> */}
    </>
  );
};
const findFlagRef = (flag, flagsRef) => {
  let flagRef = null;
  if (Array.isArray(flagsRef)) {
    flagsRef.forEach((el) => {
      if (el.id === flag.id) {
        flagRef = el;
      }
    });
  }
  return flagRef;
};
const DiffDescription = ({ flag, flagsRef }) => {
  let flagRef = findFlagRef(flag, flagsRef);
  let oldVal = "";
  let newVal = "";

  if (flagRef) {
    if (flagRef.description) {
      oldVal = flagRef.description;
    }
  }
  if (flag) {
    if (flag.description) {
      newVal = flag.description;
    }
  }
  // console.log(flag, flagRef);
  return (
    <div className={styles.DiffDescription}>
      <h3>تغییرات</h3>
      <div className={styles.DiffText}>
        {diffSentences(oldVal, newVal).map((el) => {
          if (el.added) {
            return (
              <span>
                <span className={styles.AddedText}>
                  <div className={styles.PlusSign}>
                    {" "}
                    <span>+</span>{" "}
                  </div>
                  {el.value}
                </span>
              </span>
            );
          } else if (el.removed) {
            return (
              <span>
                <span className={styles.RemovedText}>
                  <div className={styles.MinusSign}>
                    {" "}
                    <span>-</span>{" "}
                  </div>{" "}
                  {el.value}
                </span>
              </span>
            );
          }
          return <span>{el.value}</span>;
        })}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
    userData: state.userData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(memo(ActionsRoadmap));
